import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import millisecondsToTime from '../../utils/dateFormatter';
import properties from '../../modules/ajio-util/properties';
import { getLuxeFlags } from '../../Flags/selectors';
import { getCurrentStore } from '../../refresh/selectors/metaData';
import styles from '../../refresh/organism/Coupon-Card/index.pcss';

const imageBaseUrl = properties.getProperty('imageBaseUrl');
const cx = classNames.bind(styles);

class TimerStartBeforeComponent extends React.Component {
  constructor(props) {
    super(props);
    let {
      endTime,
      serverTime,
      timerStartBefore,
      luxeFlags,
      currentStore,
      pageType,
      deviceType,
      offerPriceShow,
      combinedOffersPdp
    } = this.props;
    let { result, differenceServerEndTime } = this.calculateTimer(props);
    this.state = {
      endTime,
      timerStartBefore,
      serverTime,
      result,
      differenceServerEndTime,
      luxeFlags,
      currentStore,
      pageType,
      deviceType,
      offerPriceShow,
      combinedOffersPdp
    };
    this.interVal;
  }

  calculateTimer({ endTime: et, serverTime: st, timerStartBefore: tsb }) {
    let endTime = new Date(et);
    let endTimeEpoch = endTime.getTime();
    let serverTimeEpoch = st;
    const milliseconds = (h, m, s) => (h * 60 * 60 + m * 60 + s) * 1000;
    const timerStartBefore = tsb;
    if (!timerStartBefore) {
      return {
        result: 0,
        differenceServerEndTime: 0
      };
    }
    const timeParts = timerStartBefore ? timerStartBefore.split(':') : '';
    const result = milliseconds(timeParts[0], timeParts[1], 0);
    let differenceServerEndTime = endTimeEpoch - serverTimeEpoch;
    return { result, differenceServerEndTime };
  }

  componentDidMount() {
    let { result, differenceServerEndTime } = this.state;
    if (differenceServerEndTime > 0 && differenceServerEndTime <= result) {
      this.interVal = setInterval(() => {
        this.setState(
          ({ differenceServerEndTime }) => {
            return { differenceServerEndTime: differenceServerEndTime - 1000 };
          },
          () => {
            if (this.state.differenceServerEndTime < 1000) {
              clearInterval(this.interVal);
            }
          }
        );
      }, 1000);
    }
  }

  render() {
    let {
      result,
      differenceServerEndTime,
      luxeFlags,
      currentStore,
      pageType,
      deviceType,
      offerPriceShow,
      combinedOffersPdp
    } = this.state;
    const { isThemeEnable } = luxeFlags;
    const luxe = isThemeEnable === 'ON' && currentStore === 'luxe';
    const { topTimerOrProductTimer = false ,fromFleek = false } = this.props;
    if (differenceServerEndTime > 0 && differenceServerEndTime  <= result ) {
    let { hours, minutes, seconds } = millisecondsToTime(differenceServerEndTime);
      if (topTimerOrProductTimer) {
        return (
          <div>
            {luxe ? (
              <div className="luxeTimer">
                <div
                  className="saleTimer"
                  aria-label={`SALE ENDS IN ${
                    hours !== '00' ? ` ${hours} hours :` : ''
                  } ${minutes} minutes : ${seconds} seconds`}
                >
                  SALE ENDS IN
                  <span style={{ color: '#ee9696' }}>
                    {hours !== '00' ? ` ${hours}H :` : null} {minutes}M : {seconds}S
                  </span>
                </div>
                {/* <div className="timerData">
                  30 Seconds Only / 1 GAS product per person / No Returns No Exchange / View T&C
                </div> */}
              </div>
            ) : (
              !offerPriceShow && (
                <div className="timer-component">
                  <p
                    className="timer-component-wrapper"
                    aria-label={`Ends in ${
                      hours !== '00' ? ` ${hours} hours :` : ''
                    } ${minutes} minutes : ${seconds} seconds`}
                  >
                    <strong>
                      Ends in
                      {hours !== '00' ? (
                        <span>
                          {' '}
                          <span className="time-counter">{hours}</span>
                          <span className="label">h</span>
                        </span>
                      ) : null}
                      <span className="time-counter">{minutes}</span>
                      <span className="label"> m</span>
                      <span className="time-counter">{seconds}</span>
                      <span className="label">s</span>
                    </strong>
                  </p>
                </div>
              )
            )}
          </div>
        );
    }
    else
    {
      if(pageType == 'pdp' && fromFleek)
      {
        return <div className={cx("combined-offers-timer-div", fromFleek && 'fleek-timer')}>    
          { deviceType == 'desktop' ? <img src={imageBaseUrl + "/static/img/TimerForDesktop.svg"} alt="Timer icon" id='timer-icon'/> :
            <img src={imageBaseUrl + "/static/img/Timer.svg"} alt="Timer icon" className={cx("combined-offers-timer-icon")} />
          }     
          <div  className={cx("combined-offers-timer-text")}> {hours}h {minutes}m {seconds}s </div>           
       </div> 
      }
      else if(pageType == 'pdp' && combinedOffersPdp) {
        return <div className={cx("combined-offers-timer-div")}>    
          { deviceType == 'desktop' ? <img src={imageBaseUrl + "/static/img/TimerForDesktop.svg"} alt="Timer icon" id='timer-icon'/> :
            <img src={imageBaseUrl + "/static/img/Timer.svg"} alt="Timer icon" className={cx("combined-offers-timer-icon")} />
          }     
          <div  className={cx("combined-offers-timer-text")}> {hours}h {minutes}m {seconds}s </div>           
      </div> 
      }
      else if(pageType == 'pdp' && offerPriceShow) {
          return <div id="timer-div" >    
          { deviceType == 'desktop' ? <img src={imageBaseUrl + "/static/img/TimerForDesktop.svg"} alt="Timer icon" id='timer-icon'/> :
            <img src={imageBaseUrl + "/static/img/Timer.svg"} alt="Timer icon" id='timer-icon'/>
          }     
          <div id="timer-text">                                      
            {hours}h {minutes}m {seconds}s
          </div>
          </div>
      }
      else {
        return(
          <div className="timer-main-block ">
          <p className="timer-start-before-img" id="timer-start-before-img">
                <span className="ends-in-display" id="ends-in-display">Ends in :</span>
                <span className="ends-timer" id="ends-timer">
                  <img src={`${imageBaseUrl}/static/img/endsIn.png`} alt="Timer icon" />{' '}
                  {hours !== '00' ? (
                    <span>
                      <span id="timer-color">{hours}h</span> <span id="timer-color">:</span>
                    </span>
                  ) : null}
                  <span id="timer-color">{minutes}m</span>:<span id="timer-color"> {seconds}s</span>
                </span>
              </p>
            </div>
          );
        }
      }
    } else {
      return null;
    }
  }
}
const mapStateToProps = (state, ownProps) => {
  const { endTime, serverTime, timerStartBefore } = ownProps;
  return {
    endTime,
    serverTime,
    timerStartBefore,
    luxeFlags: getLuxeFlags(state.flags),
    currentStore: getCurrentStore(state)
  };
};
export default connect(mapStateToProps)(TimerStartBeforeComponent);
